import useAnchorClickMessageDispatcher from '@carvana/merch-native/useAnchorClickMessageDispatcher';
import { useEffect } from 'react';
import useMicroFrontend from '~/components/common/MicroFrontEnds';
import { isNonProd } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useCorrelationId } from '~/context/common/GlobalLayoutContext';
import isChunkLoadError from '~/utilities/isChunkLoadError';
import { logError, logInfo } from '~/utilities/loggers';
import {
  loadItemFromSessionStorage,
  saveItemToSessionStorage
} from '~/utilities/sessionStorage';

const CHUNK_LOAD_ERROR_RELOAD_KEY = 'chunk-load-error-reload';

/** Shared functionality for app router error pages */
export default function useErrorPage(
  page: string,
  error?: Error & { digest?: string }
) {
  const correlationId = useCorrelationId();
  const trackEvent = useTrackEvent();

  useMicroFrontend(false);

  useAnchorClickMessageDispatcher({
    logError,
    source: 'error-page',
    verboseLogs: isNonProd
  });

  useEffect(() => {
    if (isChunkLoadError(error)) {
      logInfo('ChunkLoadError', {
        location: `${page} App Router Error Boundary`,
        digest: error?.digest,
        message: error?.message
      });

      if (loadItemFromSessionStorage(CHUNK_LOAD_ERROR_RELOAD_KEY)) return;

      saveItemToSessionStorage(CHUNK_LOAD_ERROR_RELOAD_KEY, '1');
      window.location.reload();

      return;
    }

    logError(error, {
      location: `${page} App Router Error Boundary`,
      digest: error?.digest
    });
  }, [error, page]);

  useEffect(() => {
    console.log('[debug] error', {
      correlationId,
      digest: error?.digest,
      message: error?.message,
      page,
      stack: error?.stack
    });
  }, [correlationId, error, page]);

  useEffect(() => {
    trackEvent('oopsPageError', {
      digest: error?.digest,
      error: error?.message,
      page
    });
  }, [error, page, trackEvent]);
}
